import { Pipe, PipeTransform, SecurityContext, VERSION } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BypassSecurityService } from '../service/bypass-security.service';

@Pipe({
  name: 'nl2br',
  standalone: true,
})
export class Nl2brPipe implements PipeTransform {
  public constructor(
    private readonly _domSanitizer: DomSanitizer,
    private readonly _bypassSecurityService: BypassSecurityService,
  ) {}

  public transform(value: string, sanitizeBeforehand?: boolean): string {
    if (typeof value !== 'string') {
      return value;
    }
    let result: any;
    const textParsed = value.replace(/(?:\r\n|\r|\n)/g, '<br />');

    if (!VERSION || VERSION.major === '2') {
      result = this._bypassSecurityService.bypassSecurityHtml(textParsed);
    } else if (sanitizeBeforehand) {
      result = this._domSanitizer.sanitize(SecurityContext.HTML, textParsed);
      result = this._bypassSecurityService.bypassSecurityHtml(result);
    } else {
      result = textParsed;
    }

    return result;
  }
}
